"use strict";
import {gh} from '../../general/general-helpers';

(function ($) {
    if ( document.body.classList.contains('readers-authors-page') ) {

        /* Rubrics slider
        -------------------------------------------------------------------*/
        const rubricsSlider = $( '.section-3__slider' );

        function rubricsSliderInit( init ) {

            // Destroy
            if ( !init ) {
                rubricsSlider.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-theme owl-loaded owl-drag');
                rubricsSlider.find('.owl-stage-outer').children().unwrap();
                return;
            }

            // Init
            rubricsSlider.addClass( 'owl-carousel owl-theme' );
            rubricsSlider.owlCarousel( {
                loop:              false,
                margin:            20,
                nav:               true,
                dots:              true,
                // mouseDrag:         false,
                slideBy: 1,
                items: 1,
                dotsClass: 'owl-dots --bw',
                navText: [
                    gh.owlSliderCustomNavArrows( 'mobile', true, 'text-white', false ),
                    gh.owlSliderCustomNavArrows( 'mobile', false, 'text-white', false ),
                ],
            } );
        } // FNC

        // inits or destroys the slider only when screen width changes
        document.addEventListener( 'designChange', () => {
            if ( ! gh.isDesktopDesign ) {
                rubricsSliderInit( true ); // init
                return;
            }
            rubricsSliderInit(); // destroy
        } );
        document.dispatchEvent( new CustomEvent( 'designChange' ) );

    } // IF this page
})(jQuery);

